import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import { observable, autorun, action, toJS } from 'mobx';
import { observer } from 'mobx-react'

import {DictionaryTrans,autobind} from './DictionaryTrans';
import reactMixin  from 'react-mixin';

import { IconImage, IconPlus, IconClose } from './Icons';
import Settings from './Settings';

@observer
@reactMixin.decorate(DictionaryTrans)
@reactMixin.decorate(autobind(Object.keys(DictionaryTrans)))
export default class UploadInfo  extends Component  {

  @observable trans = { };
  @observable style = { height: 'auto' };

  constructor(props) {

    super(props)

    this.trans = this.props.dictionaryStorage.getCurrentLangDict;

    let scope = this;


  }


  @action close(){
    Settings.setFirstUploadAccepted(false);
    Settings.setFirstUpload(false);
    $(window).trigger('UploadInfo-cancel');
  }

  @action accept(){

    if ( Settings.getSettingsFirstUploadAutoRunUpload )
    {
      $('#bf_filemedia:first input').trigger('click');
    }
    Settings.setFirstUploadAccepted(true);
    Settings.setFirstUpload(false);
    $(window).trigger('UploadInfo-accepted');

  }

  render() {

    const t = this.t;
  //  this.style.height = $('body').height();
    //style={this.style}

    return (
      <span>
        {
        ( Settings.getSettingsFirstUpload && !Settings.getSettingsFirstUploadAccepted )
        &&
        <div className={"UploadInfo"} >

            <div className={"UploadInfo-content"}>
                <span className="UploadInfo-close" onClick={()=>{this.close()}}><IconClose/></span>
                <h6 className="UploadInfo-title"><IconImage/><span> {t('Disclaimer header')}</span></h6>
                <div className="UploadInfo-text"><p dangerouslySetInnerHTML={ { __html : t('Disclaimer Body') }}></p></div>
                <span className="UploadInfo-section">
                  <span className="UploadInfo-button" onClick={()=>{this.accept()} } dangerouslySetInnerHTML={ { __html : t('Disclaimer Button') }}>
                  </span>
                </span>
            </div>

        </div>
         }
         </span>

    );
  }
}


